import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./SettingsMenuItem.css";

export const SettingsMenuItem = ({
  active,
  children,
  hoverable = true,
  ...props
}) => {
  return (
    <div
      {...props}
      className={classnames(props.className, styles.root, {
        [styles.active]: active,
        [styles.hoverable]: hoverable,
      })}
    >
      <span className={styles.icon} data-visible={active}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentcolor"
            d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
          />
        </svg>
      </span>
      <div className={styles.children}>{children}</div>
    </div>
  );
};

SettingsMenuItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hoverable: PropTypes.bool,
  icon: PropTypes.node,
};
